import queryString from 'query-string'
import storeModule from './store'
import persistencePlugin from './persistence'

export default {
	install(Vue, { router, store }) {
		store.registerModule('urlstate', storeModule)
		persistencePlugin(store)

		// Manage url states
		router.beforeEach((to, from, next) => {
			store.dispatch('urlstate/clearStates', to.path)
			if (from.path === '/' || to.path === '/') { return next() }
			if ((new RegExp(`^${from.path.replace(/\//g, '\\/')}.+`)).test(to.path)) {
				if (window.location.search !== '') {
					store.dispatch('urlstate/saveState', { path: from.path, query: window.location.search })
				} else if (store.getters['urlstate/states'][from.path]) {
					store.dispatch('urlstate/clearState', from.path)
				}
			}

			if (!Object.keys(to.query).length
				&& (new RegExp(`^${to.path.replace(/\//g, '\\/')}.+`)).test(from.path)
				&& store.getters['urlstate/states'][to.path]
			) {
				const qs = store.getters['urlstate/states'][to.path]
				return next({ ...to, query: queryString.parse(qs) })
			}

			return next()
		})
	},
}
